export default {
  "content": "<title>Medal</title><circle cx=\"256\" cy=\"352\" r=\"112\" class=\"ionicon-fill-none ionicon-stroke-width\"/><circle cx=\"256\" cy=\"352\" r=\"48\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M147 323L41.84 159.32a32 32 0 01-1.7-31.61l31-62A32 32 0 0199.78 48h312.44a32 32 0 0128.62 17.69l31 62a32 32 0 01-1.7 31.61L365 323m6-179H37m391.74-91.4L305 250M140.55 144L207 250\" class=\"ionicon-fill-none ionicon-stroke-width\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};